import { ImageRoot } from './imageRoot'
import { ImageContent } from './imageContent'

export const Image = {
  Root: ImageRoot,
  Content: ImageContent,
}
